// extracted by mini-css-extract-plugin
export default {"introDiv":"Intro_introDiv__CK90-","name":"Intro_name__ozWdj","dino":"Intro_dino__77zAu"};